var _g, _use, _use2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHolsteinKielLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 225 225",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#211e1e"
  }, /*#__PURE__*/React.createElement("use", {
    x: 246.55,
    y: 509.44,
    width: "100%",
    height: "100%",
    xlinkHref: "#a",
    transform: "translate(-142.16 -95.53)"
  }), /*#__PURE__*/React.createElement("use", {
    x: 244.76,
    y: 547.14,
    width: "100%",
    height: "100%",
    xlinkHref: "#a",
    transform: "translate(-142.16 -95.53)"
  }), /*#__PURE__*/React.createElement("use", {
    x: 245.93,
    y: 603.69,
    width: "100%",
    height: "100%",
    xlinkHref: "#a",
    transform: "translate(-142.16 -95.53)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    x: 117.13,
    y: 33.01,
    width: "100%",
    height: "100%",
    xlinkHref: "#b",
    transform: "translate(-142.16 -95.53)",
    fill: "#eb1923"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    x: 119.58,
    y: 33.01,
    width: "100%",
    height: "100%",
    xlinkHref: "#b",
    transform: "translate(-142.16 -95.53)",
    fill: "#eb1923"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.86 223.14c60.63 0 109.77-49.18 109.77-109.82S173.5 3.55 112.86 3.55C52.22 3.55 3.04 52.68 3.04 113.32s49.18 109.82 109.82 109.82",
    fill: "#00579c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.98 113.35c0-55.03 44.78-99.8 99.85-99.8 55.03 0 99.82 44.77 99.82 99.8 0 55.07-44.79 99.85-99.82 99.85-55.06 0-99.85-44.78-99.85-99.85zm-3.02 0c0 56.73 46.15 102.88 102.87 102.88s102.84-46.15 102.84-102.88c0-56.68-46.11-102.83-102.84-102.83S9.96 56.67 9.96 113.35",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.45 147.13-1.41-5.85 11.98-2.9v-.05l-13.32-2.62-1.49-6.3 14.65 3.4 15.49-11.5 1.57 6.61-10.33 7.22 3.31.85 8.47-2.02 1.42 5.85-30.34 7.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.45 147.13-1.41-5.85 11.98-2.9v-.05l-13.32-2.62-1.49-6.3 14.65 3.4 15.49-11.5 1.57 6.61-10.33 7.22 3.31.85 8.47-2.02 1.42 5.85z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.08 122.96-.53-6.01 31.07-2.75.56 5.97-31.1 2.79",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.08 122.96-.53-6.01 31.07-2.75.56 5.97z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.56 110.05 1.5-15 5.84.84-.84 8.75 6.2.6.82-8.18 5.93.56-.85 8.23 7.1.69.8-8.6 5.94.61-1.42 14.57-31.02-3.07",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.56 110.05 1.5-15 5.84.84-.84 8.75 6.2.6.82-8.18 5.93.56-.85 8.23 7.1.69.8-8.6 5.94.61-1.42 14.57z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.49 85.67 2.25-5.56 23.4 9.48 3.07-7.55 5.53 2.26-5.37 13.07-28.89-11.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.49 85.67 2.25-5.56 23.4 9.48 3.07-7.55 5.53 2.26-5.37 13.07z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.47 65.53 8.55-12.42 4.72 3.59-4.96 7.22 5.17 3.55 4.63-6.82L54.51 64l-4.64 6.82 5.85 4 4.96-7.1 4.92 3.34-8.39 12.1-25.74-17.62",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.47 65.53 8.55-12.42 4.72 3.59-4.96 7.22 5.17 3.55 4.63-6.82L54.51 64l-4.64 6.82 5.85 4 4.96-7.1 4.92 3.34-8.39 12.1z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.36 52.21 1.4-1.17c1.9-1.53.98-3.67-.2-5.08-1.49-1.82-3.06-2.58-4.87-1.05l-1.42 1.17zm-13.03-6.17 7.82-6.54c3.92-3.26 7.75-1.4 10.45 1.86 2.9 3.5 3.15 6.21 1.53 8.63l.05.04c3.38-1.9 5.4.2 8.1 3.4 4.04 4.67 4.56 5.04 5.5 4.83l.23.29-5 4.15c-1-.52-2.26-1.77-4.52-4.52-3.43-4.15-4.64-4.64-6.09-3.43l-1.78 1.46 8.4 10-4.36 3.83-20.33-24",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.36 52.21 1.4-1.17c1.9-1.53.98-3.67-.2-5.08-1.49-1.82-3.06-2.58-4.87-1.05l-1.42 1.17z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.34 46.07 7.83-6.54c3.91-3.27 7.75-1.41 10.45 1.86 2.9 3.5 3.15 6.21 1.53 8.63l.04.04c3.4-1.9 5.4.2 8.11 3.39 4.04 4.68 4.56 5.04 5.49 4.84l.24.28-5 4.16c-1.01-.53-2.26-1.74-4.52-4.48-3.43-4.2-4.64-4.68-6.1-3.47l-1.77 1.45 8.4 10-4.36 3.84z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.07 46.58.45 1.01c.92 2.14 2.14 3.55 4.03 2.74 1.94-.84 1.74-2.86 1.01-4.51-2.7-6.18-11.26 1.73-15.98-8.92-2.01-4.56-1.69-9.28 3.96-11.78 5.52-2.46 9 .08 10.93 4.48l.28.68-5.28 2.34c-.6-1.37-1.17-2.3-1.82-2.82-.6-.52-1.25-.6-2.1-.24-1.37.6-1.73 1.98-.84 4.03 2.66 5.97 11.37-1.45 15.81 8.6 2.87 6.45 1.05 10.36-4 12.62-3.99 1.74-8.34 1.9-10.97-4.03l-.8-1.86 5.32-2.34",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.07 46.58.45 1.01c.92 2.14 2.14 3.55 4.03 2.74 1.94-.84 1.74-2.86 1.01-4.51-2.7-6.18-11.26 1.73-15.98-8.92-2.01-4.56-1.69-9.28 3.96-11.78 5.52-2.46 9 .08 10.93 4.48l.28.68-5.28 2.34c-.6-1.37-1.17-2.3-1.82-2.82-.6-.52-1.25-.6-2.1-.24-1.37.6-1.73 1.98-.84 4.03 2.66 5.97 11.37-1.45 15.81 8.6 2.87 6.45 1.05 10.36-4 12.62-3.99 1.74-8.34 1.9-10.97-4.03l-.8-1.86z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.6 20.08 6.42-1L107.71 43h.04l.45-24.57 6.33-.2-2.3 31.38-7.58.85-9.04-30.38",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.6 20.08 6.42-1L107.71 43h.04l.45-24.57 6.33-.2-2.3 31.38-7.58.85z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.07 20.08 5.85 1.37-2.95 11.46 4.64 1.25 3.23-11.46 5.81 1.78-8.51 30.14-5.73-1.86 3.6-12.59-4.65-1.25-3.3 12.63-5.86-1.33 7.87-30.14",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.07 20.08 5.85 1.37-2.95 11.46 4.64 1.25 3.23-11.46 5.81 1.78-8.51 30.14-5.73-1.86 3.6-12.59-4.65-1.25-3.3 12.63-5.86-1.33z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.52 55c2.1 1.21 3.8-.97 8.07-8.4 4.28-7.41 5.37-9.96 3.27-11.17-2.06-1.2-3.75 1.01-8.03 8.44-4.31 7.38-5.36 9.96-3.3 11.13zm-2.42 4.28c-6.85-4-4.64-9.97.33-18.56 4.96-8.55 9.03-13.48 15.9-9.52 7.37 4.27 4.03 11.05-.33 18.56-4.36 7.46-8.51 13.75-15.9 9.52",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.52 55c2.1 1.21 3.8-.97 8.07-8.4 4.28-7.41 5.37-9.96 3.27-11.17-2.06-1.2-3.75 1.01-8.03 8.44-4.31 7.38-5.36 9.96-3.3 11.13z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.15 59.23c-6.86-3.99-4.64-9.96.32-18.55 4.96-8.56 9.04-13.48 15.9-9.52 7.38 4.27 4.03 11.05-.33 18.55-4.35 7.47-8.5 13.8-15.9 9.52z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.96 40.42 4.36 4.11-17.35 18.36 6.14 5.65-4.08 4.31-10.49-9.8 21.42-22.63",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.96 40.42 4.36 4.11-17.35 18.36 6.14 5.65-4.08 4.31-10.49-9.8z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.86 72.45-.93.61c-1.97 1.21-3.22 2.66-2.13 4.4 1.12 1.77 3.1 1.29 4.6.32 5.68-3.55-3.35-10.9 6.57-17.07 4.2-2.66 8.92-3.06 12.22 2.22 3.2 5.09 1.17 8.88-2.9 11.42l-.65.4-3.06-4.92c1.25-.8 2.1-1.5 2.5-2.18.44-.68.44-1.37-.04-2.1-.8-1.29-2.18-1.45-4.12-.24-5.52 3.47 3.11 11.02-6.21 16.87-6.01 3.79-10.09 2.54-13.03-2.1-2.34-3.71-3.15-7.99 2.38-11.46l1.7-1.09 3.1 4.92",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.86 72.45-.93.61c-1.97 1.21-3.22 2.66-2.13 4.4 1.12 1.77 3.1 1.29 4.6.32 5.68-3.55-3.35-10.9 6.57-17.07 4.2-2.66 8.92-3.06 12.22 2.22 3.2 5.09 1.17 8.88-2.9 11.42l-.65.4-3.06-4.92c1.25-.8 2.1-1.5 2.5-2.18.44-.68.44-1.37-.04-2.1-.8-1.29-2.18-1.45-4.12-.24-5.52 3.47 3.11 11.02-6.21 16.87-6.01 3.79-10.09 2.54-13.03-2.1-2.34-3.71-3.15-7.99 2.38-11.46l1.7-1.09z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.07 81.03-1.78-5.09 5.6-1.93 5.5 15.85-5.61 1.9-1.78-5.04-23.84 8.23-1.98-5.7 23.89-8.22",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.07 81.03-1.78-5.09 5.6-1.93 5.5 15.85-5.61 1.9-1.78-5.04-23.84 8.23-1.98-5.7z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.5 95.07 1.37 15.05-5.93.24-.8-8.75-6.22.56.72 8.2-5.89.56-.76-8.23-7.1.64.84 8.84-5.93.52-1.37-14.8 31.07-2.83",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.5 95.07 1.37 15.05-5.93.24-.8-8.75-6.22.56.72 8.2-5.89.56-.76-8.23-7.1.64.84 8.84-5.93.52-1.37-14.8z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.05 116.66-.53 6.01-31.06-2.7.52-6.01 31.07 2.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.05 116.66-.53 6.01-31.06-2.7.52-6.01z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.48 151.36a4.82 4.82 0 0 1-1.7 6.62 4.82 4.82 0 1 1-4.92-8.31 4.78 4.78 0 0 1 6.62 1.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.48 151.36a4.82 4.82 0 0 1-1.7 6.62 4.82 4.82 0 1 1-4.92-8.31 4.78 4.78 0 0 1 6.62 1.7z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.94 149.81a4.86 4.86 0 0 1-5 8.31 4.85 4.85 0 0 1 5-8.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.94 149.81a4.86 4.86 0 0 1-5 8.31 4.85 4.85 0 0 1 5-8.3z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.2 45.14c1.04.68 1.45 2.26.84 3.47-.65 1.17-1.98 1.61-3.07.88-1.05-.68-1.4-2.21-.8-3.42.6-1.22 1.97-1.62 3.02-.93",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.2 45.14c1.04.68 1.45 2.26.84 3.47-.65 1.17-1.98 1.61-3.07.88-1.05-.68-1.4-2.21-.8-3.42.6-1.22 1.97-1.62 3.02-.93z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.29 46.83c1.09.69 1.45 2.26.84 3.47-.6 1.21-1.97 1.61-3.02.93-1.05-.69-1.41-2.26-.85-3.47.65-1.21 1.98-1.62 3.03-.93",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.29 46.83c1.09.69 1.45 2.26.84 3.47-.6 1.21-1.97 1.61-3.02.93-1.05-.69-1.41-2.26-.85-3.47.65-1.21 1.98-1.62 3.03-.93z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.5 150.53 4.6 4.48-14.73 19.37.04.04 19.08-15.05 4.6 4.52-25.98 18.2-5.49-5.37 17.87-26.18",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.5 150.53 4.6 4.48-14.73 19.37.04.04 19.08-15.05 4.6 4.52-25.98 18.2-5.49-5.37z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8 191.02c2.05 1.25 3.78-.93 8.22-8.27 4.4-7.34 5.53-9.88 3.43-11.14-2.02-1.2-3.75.97-8.19 8.28-4.4 7.34-5.53 9.88-3.47 11.13zm-2.55 4.2c-6.78-4.08-4.44-10.05.69-18.52 5.12-8.51 9.28-13.36 16.1-9.24 7.3 4.36 3.79 11.1-.7 18.52s-8.75 13.63-16.09 9.24",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8 191.02c2.05 1.25 3.78-.93 8.22-8.27 4.4-7.34 5.53-9.88 3.43-11.14-2.02-1.2-3.75.97-8.19 8.28-4.4 7.34-5.53 9.88-3.47 11.13z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.21 195.25c-6.78-4.07-4.44-10.04.69-18.51 5.12-8.52 9.28-13.36 16.05-9.24 7.3 4.4 3.8 11.1-.64 18.52-4.48 7.42-8.76 13.63-16.1 9.23z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.48 172.33 6.5 1.9-.33 20.77.09.04 5.12-19.49 5.4 1.26-7.9 30.21-6.58-1.73.33-22.15h-.05l-5.44 20.82-5.65-1.5 8.51-30.13",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.48 172.33 6.5 1.9-.33 20.77.09.04 5.12-19.49 5.4 1.26-7.9 30.21-6.58-1.73.33-22.15h-.05l-5.44 20.82-5.65-1.5z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.8 138.86 1.9-6.5 20.8.45v-.08l-19.44-5.2 1.3-5.41 30.13 8.03-1.73 6.57-22.11-.44-.04.08 20.77 5.53-1.49 5.65-30.1-8.68",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.8 138.86 1.9-6.5 20.8.45v-.08l-19.44-5.2 1.3-5.41 30.13 8.03-1.73 6.57-22.11-.44-.04.08 20.77 5.53-1.49 5.65z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.16 186.17-4.84.24-.24-4.64.76-.04c4.52-.2 5.45-3.15 5.65-5.13l4.24-.2 1.49 30.9-6.01.29-1.05-21.43",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.16 186.17-4.84.24-.24-4.64.76-.04c4.52-.2 5.45-3.15 5.65-5.13l4.24-.2 1.49 30.9-6.01.29z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1 183.79c-1.06-3.47-2.15-5.53-3.84-5.04-1.65.52-1.53 2.58-.6 5.8 1.08 3.6 1.93 5.13 3.75 4.57 1.7-.49 1.49-2.67.68-5.33zm-1.62 14.04c.16.8.44 1.57.85 2.14.4.52.96.72 1.65.56 1.98-.44 2.06-2.46.48-9.07h-.04c-.36 2.01-1.7 3.18-3.79 3.67-3.8.88-6.53-1.17-8.15-7.95-1.41-6.01-1-11.34 5.53-12.87 7.3-1.7 9.48 3.75 11.62 12.75 2.34 10.04 3.14 16.18-4.84 18.07-4.4 1.01-7.63-.6-8.96-5.97l5.65-1.33",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.1 183.79c-1.06-3.47-2.15-5.53-3.84-5.04-1.65.52-1.53 2.58-.6 5.8 1.08 3.6 1.93 5.13 3.75 4.57 1.7-.49 1.49-2.67.68-5.33z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.44 197.84c.16.8.44 1.57.85 2.13.4.53.97.73 1.65.57 1.98-.44 2.06-2.46.49-9.08h-.05c-.36 2.02-1.69 3.19-3.79 3.67-3.79.9-6.53-1.17-8.15-7.94-1.4-6.02-1-11.34 5.53-12.87 7.3-1.7 9.48 3.75 11.62 12.75 2.34 10.04 3.15 16.17-4.84 18.07-4.4 1-7.63-.6-8.96-6.01z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.3 191.54c1.81-.93 1-3.2-2.95-10.98-4.03-7.86-5.36-9.8-7.18-8.87-1.81.92-1 3.14 3.03 11.01 3.95 7.79 5.28 9.76 7.1 8.84zm2.3 4.03c-6.7 3.55-10.13-1.21-14.77-10-4.15-7.87-6.74-14.33-.08-17.88 6.74-3.55 10.13 1.25 14.8 10 4.12 7.88 6.7 14.33.05 17.88",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.3 191.54c1.81-.93 1-3.2-2.95-10.98-4.03-7.86-5.36-9.8-7.18-8.87-1.81.92-1 3.14 3.03 11.01 3.95 7.79 5.28 9.76 7.1 8.84z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.57 195.56c-6.7 3.55-10.13-1.2-14.77-10-4.15-7.87-6.73-14.32-.08-17.87 6.74-3.55 10.13 1.25 14.8 10 4.12 7.87 6.7 14.32.05 17.87z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 177.18c1.48-1.41.07-3.35-5.9-9.72-6-6.46-7.82-7.99-9.32-6.58-1.49 1.37-.12 3.31 5.93 9.76 5.97 6.38 7.79 7.91 9.28 6.54zm3.3 3.23c-5.45 5.28-10.05 1.65-16.94-5.53-6.18-6.41-10.41-11.9-4.97-17.15 5.45-5.28 10.05-1.6 16.95 5.53 6.13 6.42 10.4 11.9 4.96 17.15",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177 177.18c1.48-1.41.07-3.35-5.9-9.72-6-6.46-7.82-7.99-9.32-6.58-1.49 1.37-.12 3.31 5.93 9.76 5.97 6.38 7.79 7.91 9.28 6.54z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.3 180.38c-5.45 5.29-10.05 1.66-16.95-5.52-6.17-6.42-10.4-11.9-4.96-17.15 5.45-5.29 10.05-1.62 16.94 5.53 6.14 6.41 10.37 11.9 4.97 17.14z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.27 166.34 1-.57a69.85 69.85 0 0 0 16.63-13.51c8.31-9 13.2-16.87 16.74-27.07 5.61-16.22 5.69-28.04 5.77-42.97v-2.99a52.6 52.6 0 0 1 12.43 34.05 53.07 53.07 0 0 1-52.57 53.06zm-53.5-53.06A52.6 52.6 0 0 1 72.2 79.23v2.99c.12 14.93.2 26.75 5.8 42.97 3.52 10.2 8.24 17.79 16.71 27.07a67.13 67.13 0 0 0 16.66 13.51l.97.57a53.07 53.07 0 0 1-52.57-53.06zm53.05-53.05a52.98 52.98 0 0 1 40.19 18.48l-2.3-.16c-.16-.04-19.33-1.53-37.89-1.53-18.6 0-37.72 1.49-37.92 1.53l-2.3.16a53.06 53.06 0 0 1 40.22-18.48zm0-3.1a56.26 56.26 0 0 0-56.2 56.15 56.23 56.23 0 0 0 56.2 56.16 56.22 56.22 0 0 0 56.16-56.16 56.25 56.25 0 0 0-56.16-56.15",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.86 80c-18.72 0-37.69 1.53-37.69 1.53.09 15.17.09 26.66 5.61 42.64 3.63 10.49 8.51 17.71 16.1 26.02 6.37 6.98 11.74 10.53 15.98 12.95 4.2-2.42 9.52-6 15.93-12.95 7.47-8.07 12.47-15.53 16.1-26.02 5.53-15.98 5.53-27.47 5.6-42.64 0 0-19-1.54-37.63-1.54",
    fill: "#eb1938"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m112.86 159.1-9.32-7.1 6.57-11.9-16.7 4.4 8.83-11.98-15.2 2.02 10.73-11.26-15.98-.48 11.98-9.32-15.49-2.75 14.16-8.02-13.92-6.02-.12-12.02 11.46-.72 5.8 15.69 5.86-16.22 5.6 15.5 5.78-15.98 5.72 15.97 5.61-15.49 5.85 16.22 5.81-15.7 11.46.73-.16 12.02-13.88 6.02 14.16 8.02-15.45 2.75 11.94 9.32-15.98.48 10.74 11.26-15.21-2.02 8.83 11.98-16.7-4.4 6.61 11.9-9.4 7.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#575759"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.24 103.75h-2.46c0 1-.37 1.85-.85 2.66a9.92 9.92 0 0 1-4.44 3.43v-2.86h-1.93v3.83c-1.01.32-1.98.68-3.07.97v2.26a23.77 23.77 0 0 0 11.3-6.3c-1.05 9.56-7.95 16.83-16.95 16.87-9-.05-15.77-7.39-16.94-16.87a23.7 23.7 0 0 0 11.21 6.3v-2.26l-3.18-.97s-.04-3.71 0-3.83h-1.94v2.9c-2.38-1.05-5.12-3.3-5.28-6.21h-2.42c-.53 8.8 3.5 17.5 11.65 21.22 4.89 2.38 11.78 1.61 16.22-1.33 6.74-4.64 9.6-11.82 9.08-19.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.86 118.93a24.3 24.3 0 0 0 13.51-4.07 19.09 19.09 0 0 0 1.57-3.84 25.05 25.05 0 0 1-30.1.04c.41 1.42.94 2.7 1.58 3.88 4 2.62 8.63 4 13.44 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.86 120.38c-4.2 0-8.23-1.05-11.83-3.03a15.04 15.04 0 0 0 11.83 5.97c4.84-.04 9.07-2.3 11.98-6.05a24.78 24.78 0 0 1-11.98 3.1M112.86 114.7c1.37 0 2.7-.16 3.99-.37v-2.42c-2.58.37-5.53.37-8.11 0v2.42a23 23 0 0 0 4.12.37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolsteinKielLogo);
export default __webpack_public_path__ + "static/media/Holstein_Kiel_Logo.7f4467048348d00fe18ba5584f839a50.svg";
export { ForwardRef as ReactComponent };